<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="course">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.materials_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Material de clase {{ course.name }} </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col lg="3" md="6" sm="12" xs="12">
                            <v-card>
                                <v-card-title>Nuevo registro</v-card-title>
                                <v-card-text>Dar de alta nuevo material de clase</v-card-text>
                                <v-card-actions>
                                    <v-btn text block @click="new_material_dialog = !new_material_dialog">Nuevo registro</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col lg="9" md="6" sm="12" xs="12">
                            <v-card v-if="course.materials.length > 0">
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Título</th>
                                                    <th>Descripción</th>
                                                    <th>Fecha</th>
                                                    <th>Archivo</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(material, index) in course.materials" :key="index">
                                                    <td>{{ material.title }}</td>
                                                    <td>{{ material.description }}</td>
                                                    <td>{{ material.date }}</td>
                                                    <td>
                                                        <v-tooltip right>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on" :href="download_url+material.folio">
                                                                    <v-icon>mdi-file-download</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Descargar</span>
                                                        </v-tooltip>
                                                    </td>
                                                    <td>
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on">
                                                                    <v-icon>mdi-circle-edit-outline</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Editar</span>
                                                        </v-tooltip>
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn icon v-bind="attrs" v-on="on" @click="() => { delete_item = material.id; delete_material_dialog = !delete_material_dialog  }">
                                                                    <v-icon>mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Eliminar</span>
                                                        </v-tooltip>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                            <v-card v-else outlined>
                                <v-card-text>
                                    <p class="text-center">Sin elementos disponibles</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>


        <v-dialog v-model="new_material_dialog" scrollable max-width="800">
            <v-card>
                <v-card-title>Nuevo material de clase</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-form ref="new_material_form" enctype="multipart/form-data">
                                    <v-text-field v-model="title" :rules="[rules.required]" filled color="#000" label="Título"></v-text-field>
                                    <v-textarea v-model="description" :rules="[rules.required]" filled color="#000" label="Descripción"></v-textarea>
                                    <v-text-field @keydown.space.prevent v-model="name" :rules="[rules.required]" filled color="#000" label="Nombre del archivo"></v-text-field>
                                    <v-file-input v-model="file[0]" :rules="[rules.required]" filled color="#000" label="Archivo"></v-file-input>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="() => { $refs.new_material_form.reset(); new_material_dialog = false }" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark @click="submit" :loading="loading">Registrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="delete_material_dialog" persistent max-width="400">
            <v-card>
                <v-card-title>Atención</v-card-title>
                <v-card-text>
                    <p class="text-center">¿Realmente desea eliminar este elemento?</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="delete_material_dialog = false" :disabled="loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark @click="delete_material" :loading="loading">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['dialog','course','store_url','delete_url'],
    data: () => ({
        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        download_url:"/class-materials/download/",

        loading:false,

        delete_item:"",

        new_material_dialog:false,
        delete_material_dialog:false,
        
        title:"",
        description:"",
        name:"",
        file:[],
    }),

    methods:{
        submit:function(){
            if(this.$refs.new_material_form.validate()){
                this.loading = true
                
                var data = new FormData();
                data.append('course_id',this.course.id);
                data.append('title', this.title);
                data.append('description', this.description);
                data.append('name', this.name);
                data.append('file',this.file[0]);

                axios.post(this.store_url, data).then(response => {
                    this.$refs.new_material_form.reset()
                    this.new_material_dialog = this.loading = false
                    iziToast.success({
                        title:"Correcto",
                        message:"Archivo almacenado correctamente",
                        position:"topRight"
                    })

                    this.$parent.getItems()
                    this.$parent.materials_dialog = false

                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }else{
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                        })
                    }
                })
            }
        },

        delete_material:function(){
            this.loading = true
            let data = {}
            data.material_id = this.delete_item
            axios.post(this.delete_url, data).then(response => {
                this.$parent.getItems()
                this.loading = this.delete_material_dialog = this.$parent.materials_dialog = false

                iziToast.success({
                    title:"Correcto",
                    message:"Archivo eliminado correctamente",
                    position:"topRight"
                })
            }).catch(error => {
                this.loading = this.delete_material_dialog = false
                iziToast.error({
                    title:"Error",
                    position:'topRight',
                    message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                })
            })
        }
    }
}
</script>